/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Inicio',
	homePageTabsLabel: 'Contenido inicial',
	myContent: 'Mi contenido',
	teamContent: 'Contenido del equipo',
	folder: 'Carpeta',
	files: 'Archivos',
	actionMenu: 'Menú de acciones',
	myFolder: 'Mis carpetas',

	emptyFolderNoContent: 'Sin contenido',

	//EmptyStates
	emptyRecentTitle: 'No ha visto ningún contenido recientemente.',
	emptyStateTitle: 'Comenzar añadiendo datos',
	emptyStateBody: 'Pulse Cargar datos arriba o arrastre y suelte para cargar los datos.',
	emptySearchResultTitle: 'Lo sentimos, su búsqueda no ha devuelto ningún resultado.',
	emptyPortalTitle: 'No hay portales',
	emptyPortalBody: 'Actualmente no tiene ningún portal.',
	emptyWsProjectTitle: 'Comience creando un cuaderno en Watson Studio.',
	emptyWsProjectBody: 'Cuando vuelva a Cognos Analytics, el cuaderno se mostrará aquí.',
	emptyFilteredResultTitle: 'Lo sentimos, los filtros aplicados no han devuelto ningún resultado.',
	emptyDialogViewTitle: 'No hay ningún elemento.',
	removeFromRecents: 'Eliminar de reciente',

	// Welcome Banner
	welcomeBannerGreeting: 'Hola. Bienvenido a Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson refuerza a los usuarios con análisis de autoservicio basado en IA. Vea cómo la preparación automática de datos, el descubrimiento de datos y las visualizaciones pueden generar decisiones de mayor confianza.',
	welcomeBannerDescription_trialUser: 'Puede comenzar inmediatamente utilizando nuestro vídeo de introducción, la visita guiada del producto y el separador Cómo empezar.',
	takeTourButtonLabel: 'Realice una visita guiada del producto',
	watchVideoButtonLabel: 'Ver vídeo',
	// confirmation dialog
	hideWelcomeBannerMsg: '¿Seguro que desea desactivar el banner de bienvenida de la página de inicio? Puede volver a activarlo más adelante en Perfil y valores > Valores > General, en cualquier momento. ',
	hideWelcomeBannerTitle: 'Desactivar banner de bienvenida',
	ok: 'Aceptar',
	cancel: 'Cancelar',
	warn: 'Aviso',
	//howto video dialog
	modal_how_title: 'Ver Visión general de Cognos Analytics',
	modal_overview_title: 'Ver Visión general de Cognos Analytics',
	modal_how_play: 'Reproducir vídeo',
	modal_how_video_title_overview: 'Descripción general',
	modal_how_video_title_getStarted: 'Iniciación en 11.2',
	modal_how_video_title_newUI: 'Bienvenido a la nueva experiencia de Cognos',
	modal_how_video_title_dataModule: 'Descripción general de los módulos',
	modal_how_video_title_explore: 'Descripción general de la exploración',
	modal_how_video_title_dashboard: 'Descripción general de paneles de control interactivos',
	modal_how_video_title_reporting: 'Visión general de los informes',
	modal_how_video_title_mobile: 'El poder de Cognos en la palma de la mano',

	// Toolbar
	search: 'Buscar',
	addFolder: 'Añadir carpeta',
	addLink: 'Añadir enlace',
	filter: 'Filtro',
	sort: 'Ordenar',
	settings: 'Valores',
	tilesView: 'Vista de mosaico',
	listView: 'Vista de lista',
	columnView: 'Vista de columnas ',
	backToSearch: 'Volver a los resultados de la búsqueda',

	// Toolbar Actions
	sortBy: 'Ordenar por',
	sortOrder: 'Ordenar',
	name: 'Nombre',
	modifiedTime: 'Modificado',
	type: 'Tipo',
	ascending: 'Ascendente',
	descending: 'Descendente',
	resetSort: 'Restablecer clasificación',

	filterType: 'Tipo',
	filterModificationTime: 'Modificado',
	all: 'Todo',
	today: 'Hoy',
	yesterday: 'Ayer',
	pastWeek: 'Semana pasada',
	pastMonth: 'Mes pasado',
	resetFilters: 'Restablecer filtros',
	resultLimit: 'Límite de resultados',

	filterSearchPlaceHolder: 'Filtrar por palabras clave',

	resetFilterTag: 'Pulse X para restablecer los filtros.',
	filterTagToolTip: 'Filtros aplicados: %{appliedFilters}.',

	folderName: 'Nombre de carpeta',
	addAFolder: 'Añadir a carpeta',
	add: 'Añadir',
	error: 'Error',
	newFolderDefaultName: 'Nueva carpeta',
	toastCreateNewFolder: 'Se ha creado la carpeta %{nameOfFolder} en %{tabName}.',
	folderAdded: 'Carpeta añadida',
	refresh: 'Renovar',
	openFolder: 'Abrir carpeta',

	addAUrl: 'Añadir un URL',
	linkName: 'Nombre de URL',
	linkNamePlaceholder: 'Añadir nombre de URL',
	linkDescription: 'Descripción (opcional)',
	linkDescriptionPlaceholder: 'Añadir una descripción',
	linkUri: 'URL',
	linkUriPlaceholder: 'Añadir un URL con un dominio aceptable',
	acceptableDomains: 'Dominios aceptables',
	viewAcceptableDomains: 'Ver dominios aceptables',
	mandatoryField: 'Campo obligatorio',
	linkAdded: 'URL añadido',
	toastCreateNewLink: 'Se ha añadido %{nameOfLink} a %{tabName}.',
	noEntries: 'No hay entradas en la lista de dominios aceptables. Póngase en contacto con el administrador.',
	unacceptableDomain: 'Su URL utiliza un dominio no válido. Pulse \'Ver dominios aceptables\' para ver una lista de los dominios que puede utilizar.',

	compact: 'Compacto',
	short: 'Corto',
	default: 'Valor predeterminado',
	rowSize: 'Tamaño de fila',

	// GroupyByTypes
	folders: 'Carpetas',
	reports: 'Informes',
	dashboards: 'Paneles de control',
	data: 'Datos',
	packages: 'Paquetes',
	explorations: 'Exploraciones',
	stories: 'Historias',
	notebooks: 'Cuadernos',
	others: 'Otros',

	// Error Messages
	itemsOverLimit: 'El nombre especificado "%{itemName}" ha superado el límite máximo (20). Especifique un nombre diferente para continuar.',
	errorMessageLengthFolderName: 'Escriba un nombre de carpeta que supere los 255 caracteres.',
	errorMessageLengthLinkName: 'Escriba un nombre de enlace que no supere los 255 caracteres.',
	toastLaunchPerspectiveError: 'No se puede abrir %{objectType}.',
	errorNoAccessTitle: 'Aparentemente no tiene acceso a este contenido',
	errorNoAccessBody: 'Póngase en contacto con el administrador o consulte el siguiente enlace:',
	errorEnableExternalContent: 'Habilitación del contenido externo',

	//TableHeader
	lastAccessed: 'Último acceso',
	location: 'Ubicación',
	tenant: 'Arrendatario\n',

	// GetStartedTab
	getStartedLabel: 'Comience a utilizar y ejecutar IBM Cognos Analytics',
	learningHowToLabel: 'Recursos de aprendizaje',
	learningHowToDescription: 'Expanda sus conocimientos y obtenga ayuda conectando con la comunidad, lea la documentación y vea los vídeos.',
	learningHowToActionLabel: 'Iniciar el panel de aprendizaje',
	howToVideosLabel: 'Vídeos explicativos',
	howToVideosDescription: 'Aprenda a utilizar IBM Cognos Analytics y comience a obtener conocimientos de sus datos.',
	howToVideosActionLabel: 'Vea los vídeos',
	acceleratorCatalogLabel: 'Catálogo del acelerador',
	acceleratorCatalogDescription: 'Explore un catálogo creciente de uso industrial, las guías de mejores prácticas, visualizaciones personalizadas, y más cosas.',
	acceleratorCatalogActionLabel: 'Explorar el catálogo',
	sampleSectionTitle: 'Ejemplos',
	sampleSectionDescription: 'Experimente con los ejemplos que muestran todo lo que Cognos Analytics puede ofrecerle.',
	// Samples Section
	createDashboardSampleTitle: 'Cómo crear su primer panel de control',
	createDashboardSampleDescription: 'Inicie su recorrido analítico con Cognos Dashboards.',
	nlaSampleTitle: 'Ejemplo de informe',
	nlaSampleDescription: 'Explore qué es posible con Cognos Analytics Reports con este ejemplo que analiza la actividad de los miembros de una tarjeta de fidelidad a final de año.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Expanda su biblioteca de visualizaciones con visualizaciones personalizadas, como el gráfico Sankey.',
	viewAllSamplesActionLabel: 'Ver todas las muestras',
	byFeatureTitle: 'Por característica',
	byFeatureDescription: 'Examine los ejemplos por característica, como la funcionalidad principal, los controles personalizados, las extensiones, los cuadernos y las fechas relativas.',
	byIndustryTitle: 'Por sector',
	byIndustryDescription: 'Examine los ejemplos por sector, como automoción, banca y más.',
	// SamplesTab
	sampleTabTitle: 'Inspírese con nuestras muestras precompiladas',
	sampleTabLabel: 'Visite el catálogo de Accelerator para obtener más ejemplos y extensiones de IBM, partners y clientes',

	// quickLaunch
	quickLaunchLabel: 'Inicio rápido',
	expand: 'Expandir',
	collapse: 'Contraer',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Comience por elegir lo que desea crear.',

	// contentPageView
	contentPageTitleLabel: 'Contenido',
	uploadFile: 'Cargar datos',
	new: 'Nuevo',
	create: 'Crear',
	more: 'Más',

	// open dialog
	selectDataSourcesToAdd: 'Seleccione orígenes de datos para añadir.',
	openDialogDefaultTitle: 'Abrir',

	// save dialog
	save: 'Guardar',
	saveAs: 'Guardar como',
	saving: 'Guardando...',
	selectedDestination: 'Destino seleccionado: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' ya existe con un tipo diferente. Elija otro nombre.',
	confirmOverwriteTitle: 'Confirmar sustitución de datos existentes',
	confirmOverwriteMsg: 'El archivo \'%{nameOfFile}\' ya existe. ¿Desea reemplazar sus datos por los del archivo seleccionado?',

	// copy move dialog
	copy: 'Copiar',
	move: 'Mover',
	copyOrMove: 'Copiar o mover: ',
	copyOnly: 'Copiar ',
	createShortcut: 'Crear acceso directo',
	createShortcutDialogTitle: 'Crear acceso directo: ',

	// External asset types
	wsProject: 'Proyecto de Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paquete',
	dataModule: 'Módulo de datos',
	exploration: 'Exploración',
	mode: 'Modo',
	live: 'Dinámico',
	snapshot: 'Instantánea',
	noSnapshotsFound: 'No se ha encontrado ninguna instantánea',
	uploadedFile: 'Archivo cargado',
	fileUpload: 'Cargar datos',
	dataSetEx: 'Conjunto de datos',
	externalRepository: 'Repositorio externo',
	queryMode: 'Modo de consulta',
	queryModeCompatible: 'Compatible',
	queryModeDynamic: 'Dinámico',
	report: 'Informe',
	activeReport: 'Informe activo',
	query: 'Consulta',
	analysis: 'Análisis',
	dashboard: 'Panel de control',
	dashboardTemplate: 'Plantilla de panel de control',
	jupyterNotebook: 'Cuaderno',
	wsNotebook: 'Cuaderno de Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Historia',
	workspace: 'Espacio de trabajo',
	pagelet: 'Página',
	content: 'Contenido',
	directory: 'Espacios de nombres',
	dataSet: 'Conjunto de datos',
	powerPlayCube: 'Cubo de PowerPlay',
	powerPlayReport: 'Informe de PowerPlay',
	powerPlay8Report: 'Informe de PowerPlay',
	setPowerPlay8ReportOptions: 'Establecer opciones de informe de PowerPlay',
	powerPlay8ReportView: 'Vista de informe de PowerPlay',
	reportTemplate: 'Plantilla de informe',
	packageConfigurations: 'Configuración de paquete',
	agent: 'Agente',
	agentDefinition: 'Definición de agente',
	agentDefinitionView: 'Vista de agente',
	dataMovementTask: 'Tarea de movimiento de datos',
	dataMovementTaskAlias: 'Alias de la tarea de movimiento de datos',
	document: 'Documento',
	DocumentRetention: 'Propiedades del documento',
	jobDefinition: 'Definición del proceso',
	job: 'Trabajo',
	jobs: 'Trabajos',
	metricsDataSourceETLTask: 'Tarea ETL de origen de datos de métricas',
	metricsExportTask: 'Tarea de exportación de métricas',
	metricsFileImportTask: 'Tarea de importación de métricas',
	metricsMaintenanceTask: 'Tarea de mantenimiento de métricas',
	planningTask: 'Tarea de planificación',
	shortcut: 'Atajo',
	shortcuts: 'Accesos directos',
	URL: 'URL',
	launchable: 'Se puede lanzar',
	dataSetFolder: 'Carpeta de conjuntos de datos',
	ViewAccessibleLabel: 'Ver %{label}',
	overrideReportOptions: 'Reemplazar las opciones de informe predeterminadas',
	formats: 'Formatos',
	saveReport: 'Guardar el informe',
	reportView: 'Vista de informe',
	reportviews: 'Vistas de informes',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Datos de Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rol',
	namespace: 'Espacio de nombres',
	namespaceFolder: 'Carpeta de espacio de nombres',
	adminFolder: 'Carpeta de administrador',
	//Details
	details: 'Detalles',
	open: 'Abrir',
	created: 'Fecha de creación',
	modified: 'Modificado',
	owner: 'Propietario',
	dataSource: 'Origen de datos',
	share: 'Compartir',
	addToFavorites: 'Añadir a favoritos',
	properties: 'Propiedades',
	detailsEmptyStateBody: 'Seleccione un elemento para ver los detalles',
	editNameAndDescription: 'Editar nombre y descripción',
	none: 'Ninguno',
	setPdfOptions: 'Establecer opciones de PDF',
	runOptions: 'Opciones de ejecución',

	//rename dialog
	nameInvalid: 'El nombre no es válido',
	namePlaceholder: 'Escriba un nombre',
	description: 'Descripción',
	descriptionInvalid: 'La descripción no puede superar los 350 caracteres.',
	descriptionPlaceholder: 'Escriba una descripción',
	errorMessageApostropheError: 'Escriba un nombre de archivo que no contenga los caracteres \' y ".',
	renameCollisionError: '%{name} ya existe. Pruebe con otro nombre.\n',
	unknownRenameError: 'Error al renombrar el elemento. Póngase en contacto con el administrador para obtener ayuda adicional.\n',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'No se ha podido abrir la carpeta especificada.',

	//Upload
	uploadToFolder: "Cargar en <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Cargar en <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> e iniciar %{launchAction}",
	quickUpload: "Carga rápida",
	quickUploadAndLaunch: "Arrastre y suelte archivos para cargarlos en <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> y abrirlos en uno de los espacios siguientes.",
	unsupportedFilesSingle: "%{files} no se ha cargado debido a que no es válido para el inicio rápido.",
	unsupportedFilesMultiple: "No se han cargado los archivos debido a que todos los archivos que seleccione deben ser válidos para el Inicio rápido.",
	unsupportedFilesSingleInvalid: "%{files} no es válido.",
	unsupportedFilesMultipleInvalid: "%{files} no son válidos.",
	supportedFileTypes: "Solo se permiten los tipos de archivos siguientes: %{extensions}.",
	uploadDragAndDrop: "Arrastrar y soltar",
	uploadDragAndDropMessage: "Arrastre y suelte su archivo aquí para cargarlos en <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Se ha guardado el criterio de búsqueda \'%{searchTerm}\'.',
	searchWasntSaved: 'No se ha guardado el criterio de búsqueda \'%{searchTerm}\'.',
	searchSuggestions: 'Sugerencias',
	savedSearch: 'Búsquedas guardadas',
	searchWasDeleted: 'Se ha suprimido el criterio de búsqueda \'%{searchTerm}\'.',
	searchWasntDeleted: 'No se ha suprimido el criterio de búsqueda \'%{searchTerm}\'.',
	savedBarTitle: 'Buscar en Cognos Analytics',
	searchContentPageTitle: 'Buscar',
	searchContentPageTitleLabel: 'Mostrando los resultados para \'%{searchTerm}\'',
	showingSearchRsult: 'Mostrando %{resultCount} elementos',
	saveSearch: 'Guardar búsqueda',
	saveTenSearches: 'Puede guardar 10 búsquedas.',
	deleteASearch: 'Suprima una para guardar otra.',
	close: 'Cerrar',
	allContent: 'Todo el contenido',
	searchResultIn: 'Buscar resultados en: ',
	//recent view
	recents: 'Reciente',
	noAccessRecent: 'Sin acceso',
	noAccessRecentMsg: 'No tiene acceso a este activo. Es posible que se haya inhabilitado o suprimido o que se hayan reducido sus permisos. Compruebe el estado del activo y su ubicación de origen prevista. Puede eliminar el activo de sus elementos recientes pulsando Aceptar.',
	noAccessMsg: 'No tiene acceso a este activo. Es posible que se haya inhabilitado o suprimido o que se hayan reducido sus permisos.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elementos seleccionados',
	itemSelected: '%{nameOfSelection} elemento seleccionado',

	//properties
	general: 'Tema general',
	schedule: 'Planificación',
	permission: 'Permisos',
	capabilities: 'Prestaciones',
	propertiesTabsLabel: 'Contenido de propiedades',
	searchPath: 'Ruta de búsqueda',
	id: 'ID',
	language: 'Idioma',
	setLanguage: 'Establecer lenguaje',
	entryOptions: 'Opciones de entrada',
	setPackage: 'Establecer paquete o módulo',
	sourcePackage: 'Paquete de datos de origen o módulo de datos',
	associatedSourceAgent: 'Paquete de origen',
	setAssociatedSourceAgent: 'Establecer paquete',
	sourceAgent: 'Agente de origen',
	setSourceAgent: 'Establecer agente de origen',
	setCapabilities: 'Establecer funcionalidades',
	disableEntry: 'Inhabilitar esta entrada',
	hideEntry: 'Ocultar esta entrada',
	permissions: 'Permisos',
	promptForValues: 'Solicitar valores',
	yes: 'Sí',
	no: 'No',
	setValues: 'Establecer valores',
	moreOptions: 'Más opciones',
	reportFormat: 'Formato del informe',
	enableAccessibilitySupport: 'Habilitar el soporte de accesibilidad',
	displayOfRunHistory: 'Visualización del historial de ejecución',
	occurrences: 'Apariciones',
	days: 'Día(s)',
	months: 'Mes(es)',
	displayOfReportOutputVersions: 'Visualización de la versión de salida del informe',
	defaultDisplayOfPortalAction: 'Acción de portal predefinida',
	viewMostRecentReport: 'Ver informe más reciente',
	runTheReport: 'Ejecutar el informe',
	openWithReportStudio: 'Abrir con Report Studio',
	rowsPerPageInHtmlReports: 'Filas por página en informes HTML',
	enableSelectionBasedInteractivity: 'Habilitar interactividad basada en selecciones',
	enableAlertsAboutNewVersions: 'Habilitar alertas sobre nuevas versiones',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Habilitar características de usuario mejoradas en las versiones de salida guardadas',
	enableCommentsInSavedOutputVersions: 'Habilitar comentarios en versiones de salida guardadas',
	run: 'Ejecutar',
	runWithUsersCredentials: 'Con credenciales de usuario',
	runWithOwnerCapabilities: 'Con capacidad de propietario',
	runAsOwner: 'Como %{ownerName}',
	actionLabelOn: 'Activar',
	actionLabelOff: 'Desactivar',
	openReport: 'Editar',
	openAnalysis: 'Abrir con Analysis Studio',
	openQuery: 'Abrir con Query Studio',
	openPowerPlay8Report: 'Abrir con PowerPlay Studio',
	openInteractiveReport: 'Editar',
	read: 'Leer',
	write: 'Escribir',
	execute: 'Ejecutar',
	setPolicy: 'Establecer política',
	full: 'Completa',
	traverse: 'Atravesar',
	grant: 'Otorgar',
	deny: 'Denegar',
	permissionCustom: 'Personalizada',
	permissionDetailsColumnAccess: 'Acceso',
	permissionDetailsColumnPermission: 'Permiso',
	permissionDetailsColumnAction: 'Acción',
	permissionSetAccess: 'Establecer acceso',
	permissionRead: 'Leer',
	permissionRun: 'Ejecutar',
	permissionWrite: 'Escribir',
	permissionFull: 'Completa',
	unavailable: 'No disponible',
	unkownSource: 'Desconocido, abra informe para ver los detalles',
	tenantSettings: 'Valores de arrendatario',
	tenantSet: 'Arrendatario actualizado',
	tenantSetError: 'Error al establecer arrendatario',
	tenantClear: 'Arrendatario borrado',
	tenantClearError: 'Error al borrar arrendatario',
	shortcutTo: 'Acceso directo a',
	sourceReport: 'Informe de origen',
	setSourceReport: 'Establecer informe de origen',
	setSourceLocation: 'Establecer ubicación de %{itemName} de origen',
	linkPackageOrModule: 'Enlazar el %{itemName} con un paquete o módulo de datos',
	linkPackage: 'Enlazar el %{itemName} con un paquete',
	externalRepositories: 'Repositorios externos',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Hora de actualización',
	size: 'Tamaño',
	tenantsWarningMessage: 'Al cambiar el arrendatario de una entrada también se cambia el arrendatario de las entradas hijo.',
	confirmClearTenantText: 'Si se borra el valor a \'Ninguno\' se puede permitir que otros inquilinos accedan al contenido. Pulse Aceptar para hacer pública la entrada o Cancelar para mantener el arrendatario actual.',
	confirmClearTenant: 'Confirmar borrado de arrendatario',
	currentValues: 'Valores actuales',
	emptyPromptValues: 'Actualmente no hay valores',
	editValues: 'Editar valores',
	clear: 'Borrar',
	source: 'Origen',
	dataRefreshed: 'Datos renovados',
	//PDF options
	pdfOptions: 'Opciones de PDF',
	set: 'Establecer',
	portrait: 'Vertical',
	landscape: 'Horizontal',
	letter: 'Letra',
	legal: 'Avisos legales',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Orientación',
	pageDefination: 'Tamaño del papel',
	openPasswordRequired: 'Requerir contraseña para abrir el informe',
	accessPasswordRequired: 'Requerir contraseña para acceder al informe',
	emptyPassword: 'La contraseña no puede quedar vacía',
	password: 'Contraseña',
	enterPassword: 'Entre la contraseña',
	confirmPassword: 'Confirmar contraseña',
	passwordMatchError: 'Las contraseñas no coinciden',
	gateway: 'Pasarela',
	pageLayout: 'Diseño de página',
	pageStyle: 'Estilo',
	setUrl: 'Establecer URL',
	numberRows: 'Número de filas',
	numberColumns: 'Número de columnas',
	timeToRefresh: 'Tiempo que falta para renovar',
	lastRefreshedBy: 'Renovado por',
	unknown: 'Desconocido',
	unknownUpdateError: 'Ha fallado la actualización del elemento. Póngase en contacto con el administrador para obtener ayuda adicional.',
	editQuery: 'Editar consulta',
	greaterOrEqual: 'Mayor o igual que %{upperboundValue}',
	lessOrEqual: 'Menor o igual que %{lowerboundValue}'
});
